import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";
import { useProjectStore } from "@/zapi-frontend/stores/project";
import { useFeatureFlag } from "@/zapi-frontend/shared/hooks/useFeatureFlag";
import type { TSectionPage } from "../model/types";
import { groupProjectChapters } from "../lib/groupProjectChapters";
import { deriveSectionPage, parseSectionTabId } from "../lib/sectionPage";
import { useProjectViewNavigation } from "./useProjectViewNavigation";

export function useSectionPage(): TSectionPage | null {
  const { t } = useTranslation("projectHome");
  const { projectChapters, activeChapter, viewMode } = useChapterStore();
  const { selectedProject } = useProjectStore();
  const { navigate } = useProjectViewNavigation();
  const isTemplateLess = selectedProject?.projectTemplateSlug === "";
  const hasValueChain = useFeatureFlag("value-chain", selectedProject?.organizationId) === true && !isTemplateLess;
  const groups = useMemo(() => groupProjectChapters(projectChapters), [projectChapters]);

  const onTabChange = useCallback((tabId: string) => navigate(parseSectionTabId(tabId)), [navigate]);

  const page = deriveSectionPage({ viewMode, activeChapter, groups, isTemplateLess, hasValueChain, t });
  return page ? { ...page, onTabChange } : null;
}
